import React, { Component } from 'react'
import styles from '../style.module.less'
import { HeaderView } from '@merchant-backend/common-components'

export default class extends Component {
  render() {
    let header = [
      <a href="#/localMerchant/marketingTools?key=17">套餐热标</a>,
      <span>热标说明</span>
    ]
    return (
      <HeaderView title="热标说明" header={header}>
        <div className={styles.box}>
          {/*<img src="http://qnm.hunliji.com/o_1b9dflbns107732i1k3oa2ogt89.jpg"/>*/}
          {/*<img src="http://qnm.hunliji.com/o_1b9dflbns1dfpgmigfhphi1b4va.jpg"/>*/}
          {/*<img src="http://qnm.hunliji.com/o_1b9dflbnstp3136rur4o6q1camb.jpg"/>*/}
          <img src="https://qnm.hunliji.com/o_1cjnr3el61isvdgs1qnk1lge1sco7.png" />
        </div>
      </HeaderView>
    )
  }
}
